import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface LocationSelectionData {
    addresses: any[];
}

@Component({
    selector: 'app-location-selection-dialog',
    templateUrl: './location-selection-dialog.component.html',
    styleUrls: ['./location-selection-dialog.component.scss'],
    standalone: false,
})
export class LocationSelectionDialogComponent {
    constructor(
        public dialogRef: MatDialogRef<LocationSelectionDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: LocationSelectionData
    ) {}

    selectLocation(address: any): void {
        this.dialogRef.close(address);
    }

    onCancel(): void {
        this.dialogRef.close();
    }
}
